/* unplugin-vue-components disabled */import { render } from "./success-login.vue?vue&type=template&id=4b52055a&scoped=true"
import script from "./success-login.vue?vue&type=script&lang=js"
export * from "./success-login.vue?vue&type=script&lang=js"

import "./success-login.vue?vue&type=style&index=0&id=4b52055a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b52055a"],['__file',"src/pages/oauth/success-login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b52055a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b52055a', __exports__)) {
    api.reload('4b52055a', __exports__)
  }
  
  module.hot.accept("./success-login.vue?vue&type=template&id=4b52055a&scoped=true", () => {
    api.rerender('4b52055a', render)
  })

}


export default __exports__